<div mat-tab-nav-bar class="content-wrapper sub-menu">
  <a mat-tab-link
     href="#"
     routerLink="/audit"
     routerLinkActive #auditLinkActive="routerLinkActive"
     [routerLinkActiveOptions]="{exact:true}"
     [active]="auditLinkActive.isActive"
  >ALL AUDITS</a>
  <a mat-tab-link
     href="#"
     routerLink="/audit/all/findings"
     [routerLinkActiveOptions]="{exact:true}"
     routerLinkActive #findingLinkActive="routerLinkActive"
     [active]="findingLinkActive.isActive"
  >ALL FINDINGS</a>
  <a mat-tab-link
     href="#"
     routerLink="/audit/all/capa"
     routerLinkActive #capaLinkActive="routerLinkActive"
     [routerLinkActiveOptions]="{exact:true}"
     [active]="capaLinkActive.isActive"
  >ALL CAPAS</a>
</div>
